'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var domReady = exports.domReady = function domReady(callback) {
  if (['interactive', 'complete'].includes(document.readyState)) {
    callback();
  } else {
    document.addEventListener('DOMContentLoaded', callback);
  }
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/listeners/domReady.js
// module id = 172
// module chunks = 177